export const interfaceSuffix = "Props";
export const contentTypeSuffix = "ContentType";
export const publicApiSuffix = "List";
